import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.52 8.695A4.667 4.667 0 1 0 8.695 9.52l3.143 3.143.825-.825L9.52 8.695ZM9.333 5.833a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.583 6.417H4.083V5.25h3.5v1.167Z",
		clipRule: "evenodd"
	})]
});
export default SvgZoomOut;
